import { Text, Toast } from "@dxp-feed/ui";
import { FC } from "react";

interface IToastComponent {
    children: React.ReactNode;
    autoCloseDuration?: number;
    position?: string;
}

const ToastComponent: FC<IToastComponent> = ({ children, autoCloseDuration, position }) => {

    // const handleClose = () => {
    //     throw new Error("Function not implemented.");
    // }

    return (
        <Toast
            message={children}
            autoCloseDuration={autoCloseDuration ?? 10000}
            position={position ?? "top"}
            onClose={()=>{}}
            closeButton={<Text as="span" className="demo-icon icon-close text-brandBlack text-[14px] cursor-pointer mt-[6px] mr-[20px]" />}
            className="font-normal flex z-[9999] w-[96%] max-w-[836px] bg-brandWhite items-start mt-[46px] py-[6px] px-[0px]"
        />
    )
}

export default ToastComponent